<template>
<div>
	<div v-if="error > 0" class="alert alert-danger fade in"
		style="margin-top: 25px">
		<span v-html="$t('misc.errorDataLoading')"></span><br> <span
			v-if="error == 1">{{$t('misc.errorServerResponse', {status: status})}}</span> 
			<span v-else>{{$t('misc.errorNoServerResponse')}}</span>
	</div>

	<div v-else-if="loading"
		class="text-center" style="margin-top: 25px">
		<strong> <i class="fa fa-refresh fa-spin" />
			{{$t('misc.waitLoading')}}
		</strong>
	</div>

  <select v-else class="selectpicker form-control inputElement" :id="'select-'+id" data-live-search="true" v-on:change="changeListener">
    <option v-for="option in options" :key="'option-'+option.id" :value="option.id" v-if="!option.hasOwnProperty('category')">{{option.value}}</option>
    <optgroup :label="option.category" v-else>
    	<option v-for="item in option.options" :key="'option-'+item.id" :value="item.id">{{item.value}}</option>
    </optgroup>
  </select>
</div>
</template>

<script>
import 'bootstrap-select/dist/js/bootstrap-select.min'
import 'bootstrap-select/dist/css/bootstrap-select.min.css'
export default {
  name: "DropdownInput",
  data() {
    return {
      options: {},
      loading: true,
      error: 0,
      status: 0
    };
  },
  props: ["value", "id", "get", "data"],
  
  
  watch: { 
      data: function() { 
    		this.getData();
      }
  },
  
  
  mounted() {
	this.getData();
  },
  
  methods: {
	  changeListener(event){
	  	this.$emit('select-change', event.target.value)
	  },
	  
	  getData() {
		  if(this.get !== undefined) {
				this.loading = true;
				this.error = 0;
			    axios
			      .get(this.get)
			      .then(response => {
			        this.options = response.data;
			    	this.loading = false;
			        this.$nextTick(() => {
						this.prepareDropdown();
			        });
			      })
			      .catch(error => {
			          if (error.response) {
			  	    	this.error = 1;
				    	this.status = error.response.status;
			          } else if (error.request) {
				  	    this.error = 2;
			          } 
			    });	
		  } else if(typeof this.data !== "undefined" && this.data !== null) {
				this.loading = false;
				this.options = this.data;
				this.$nextTick(() => {
					this.prepareDropdown();
		        });
		  }
	  },
	  
	  
	  prepareDropdown() {
	      var check = this.value;
          var select = -1;
          
          var context = this;
          $("#select-" + this.id + " option").each(function() {
         	 if(this.text == "noValue"){
             	$(this).text(context.$t('misc.noValue'));  
         	 }
          }); 
          
          
          if(check !== null) {
              $("#select-" + this.id + " option").each(function() {
                  if (this.text == check) {
                    select = this.value;
                    return false;
                  }           
                }); 
          }
          if(select !== -1){
          	$("#select-" + this.id).val(select);
          } else {
        	$("#select-" + this.id + " option").first().attr("selected", "selected");
          }
          $("#select-" + this.id).selectpicker('destroy')
          $("#select-" + this.id).selectpicker();
	  }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/DropdownInput.vue